import React from 'react';
import HeaderHome from './HeaderHome';
import MainPageHome from './MainPageHome';
import CarouselHome from './CarouselHome';
import { Helmet } from "react-helmet";

const DashboardComponent = () => {
    return (
        <>
            <Helmet>
                <meta charSet='utf-8' />
                <title>{`Portal Satu Data | Kabupaten Musi Banyuasin`}</title>
                <meta name='description' content={`Portal Satu Data - Kabupaten Musi Banyuasin`} />
            </Helmet>
            <HeaderHome />
            <CarouselHome />
            <MainPageHome />
        </>
    )
}

export default DashboardComponent;